import { render, staticRenderFns } from "./OrderPaymentBid.vue?vue&type=template&id=6ef5fb5f&scoped=true&"
import script from "./OrderPaymentBid.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentBid.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentBid.vue?vue&type=style&index=0&id=6ef5fb5f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5fb5f",
  null
  
)

export default component.exports